import { ca } from '@cian/analytics';

export function trackLayoutEntryClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'Click',
    label: 'Layout',
  });
}

export function trackLayoutWith3DTourEntryClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'Click',
    label: 'Layout_3dtour_anchor',
    useLastProducts: true,
  });
}

export function trackLayoutWith3DTourEntryShow() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'Show',
    label: 'Layout_3dtour_anchor',
    useLastProducts: true,
  });
}
